import { useEffect } from 'react';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';

const AuctionTimeReviewsView = (props) => {

    const loadingSpinner = () => {
        return (
            <LoadingRing sxBox={{
                'height': '76px',
                'position': 'absolute',
                'align-items': 'center',
                'justify-content': 'center',
                'left': '0',
                'right': '0'
            }} />
        );
    };

    useEffect(() => {
        if (typeof document !== 'undefined') {
            (function (d, s, id, c) {
                var js, rC = [], uRC = [], r = 0;
                Array.from(d.querySelectorAll('[class*="stjr-"]')).forEach(r => {
                    rC = [...rC, ...Array.from(r.classList).filter((cl) => {
                        return /^stjr-/.test(cl);
                    })];
                });
                uRC = [...new Set(rC)];
                var t = d.getElementsByTagName(s)[0];
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://www.sitejabber.com/js/v2/64834bf8559d8/widgets.js' + (uRC.length ? '?widget-classes=' + uRC.join("|") : '?widget-classes=stjr-base') + '';
                js.onload = js.onreadystatechange = function () {
                    if (!r && (!this.readyState || this.readyState[0] == 'c')) {
                        r = 1;
                        c();
                    }
                };
                t.parentNode.insertBefore(js, t);
            }(document, 'script', 'sj-widget', function () { }));
        }
    }, []);

    return (

        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                <h1 className='pagename border-bottom'>{props.PageTitle}</h1>
            </div>
            <div Class="contact-us-container">
                <div className="stjr-review-grid-page">
                    {loadingSpinner() }
                </div>
            </div>
        </div>
    );
};

export default AuctionTimeReviewsView;
global.AuctionTimeReviewsView = AuctionTimeReviewsView;